/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Col, Label, Button, Alert,
} from 'reactstrap';
import {
  Formik, Field, FieldArray, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { get, post } from '../../helpers/api_helper';
import * as urls from '../../helpers/url_helper';

function UserForm(props) {
  const { actionUrl } = props;

  // eslint-disable-next-line no-unused-vars
  const [roles, setRoles] = useState([]);
  const [url, setActionUrl] = useState(actionUrl);
  const [loadingRoles, setLoadingRoles] = useState(true);
  const [loading, setLoading] = useState(false);
  const [successFlag, setSuccessFlag] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const fetchRoles = async () => {
      const data = await get(urls.GET_ROLES);

      setRoles(data);
      setLoadingRoles(false);
    };

    fetchRoles();
  }, []);

  const makeUser = async (values, rst) => {
    try {
      setLoading(true);
      const result = await post(url, values);
      rst();
      setErrorMessage(null);
      setSuccessFlag(true);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
      setSuccessFlag(false);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    display_name: Yup.string().required('Display Name is required'),
    email: Yup.string()
      .email('Invalid email address format')
      .required('Email is required'),
    roles: Yup.array().min(1, 'At least 1 role must be selected'),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const jsx = (
    <>
      <Alert color="success" className="mt-3" isOpen={(successFlag)}>
        User created successfully
      </Alert>
      { em }
      <Formik
        enableReinitialize
        initialValues={{ display_name: '', email: '', roles: [] }}
        validationSchema={ValidationSchema}
        onSubmit={(values, actions) => {
          makeUser(values, actions.resetForm);
        }}
      >
        {({
          touched, setFieldValue, errors, values,
        }) => (
          <Form className="mt-3" autoComplete="off" id="UserForm">
            <div className="row mt-4 mb-4">
              <Label
                for="makedname"
                className="col-sm-3 col-form-label"
              >
                Display Name
              </Label>
              <Col sm={9}>
                <Field
                  type="text"
                  className={`form-control ${(errors.display_name && touched.display_name ? 'is-invalid' : '')}`}
                  id="makedname"
                  name="display_name"
                />
                <ErrorMessage
                  name="display_name"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="makedrealname"
                className="col-sm-3 col-form-label"
              >
                Real Name
              </Label>
              <Col sm={9}>
                <Field
                  type="text"
                  className={`form-control ${(errors.real_name && touched.real_name ? 'is-invalid' : '')}`}
                  id="makedrealname"
                  name="real_name"
                />
                <ErrorMessage
                  name="real_name"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>

            <div className="row mb-4">
              <Label
                for="makeemail"
                className="col-sm-3 col-form-label"
              >
                Email Address
              </Label>
              <Col sm={9}>
                <Field
                  type="text"
                  className={`form-control ${(errors.email && touched.email ? 'is-invalid' : '')}`}
                  id="makeemail"
                  name="email"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>

            <div className="row mb-4">
              <Label
                for="roles"
                className="col-sm-3 col-form-label"
              >
                {loadingRoles === true && <div>Loading </div>}
                Roles
              </Label>

              <Col sm={9}>
                <FieldArray
                  name="roles"
                  render={(arrayHelpers) => (
                    <>
                      {roles.map((role, index) => (
                        <div key={role.id} className="form-check form-check-primary mb-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`roleCheck${index}`}
                            name="roles"
                            value={role.id}
                            checked={values.roles.includes(role.id)}
                            onChange={(event) => {
                              if (event.target.checked) {
                                arrayHelpers.push(role.id);
                              } else {
                                const idx = values.roles.indexOf(role.id);
                                arrayHelpers.remove(idx);
                              }
                            }}
                          />
                          <label className="form-check-label" htmlFor={`roleCheck${index}`}>
                            {role.name}
                          </label>
                        </div>
                      ))}
                      {errors.roles && touched.roles && (
                        <>
                          <div className="is-invalid" />
                          <ErrorMessage
                            name="roles"
                            component="div"
                            className="invalid-feedback"
                          />
                        </>
                      )}
                    </>
                  )}
                />
              </Col>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

UserForm.defaultProps = {

};

UserForm.propTypes = {
  actionUrl: PropTypes.string.isRequired,
};

export default UserForm;
